module.exports = __webpack_public_path__ + "img/preferences_illustration_card.2f6332ff.png";